@if (isCrossGame) {
  <c-container class="mt-5">
    <h2>Draw Winner</h2>
    <app-choose-your-game (gameChosenEvent)="onGameChange($event)"
                          [message]="'Choose a game in order to draw winners for that game manually'"
                          [manuallyDrawnOnly]="true"></app-choose-your-game>

    @if (chosenGame) {
      <app-draw-winner></app-draw-winner>
    }
  </c-container>
} @else {
  <app-draw-winner></app-draw-winner>
}
